import styled from "@emotion/styled";
import { MDSListBox } from "../list-box";

export const StyledMDSListBox = styled(MDSListBox)`
  gap: 0;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
